import React, { useState } from "react";
import {
    Box,
    Typography,
    Grid,
    IconButton,
    Paper,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import CustomButton from "components/Fileds/CustomButton";
import ConfirmationDialog from "components/Modal/ConfirmationDialog/ConfirmationDialog";

const RestaurantPhotos = ({
    foodPhotos = [],
    ambiancePhotos = [],
    onAddClick,
    onDeleteClick,
    activeTab = "food",
    onTabChange,
}) => {
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [photoToDelete, setPhotoToDelete] = useState(null);

    const currentPhotos = activeTab === "food" ? foodPhotos : ambiancePhotos;
    const currentType = activeTab === "food" ? "food" : "ambiance";
    const photoLabel = activeTab === "food" ? "food" : "ambience";

    const imageBaseUrl = `${process.env.REACT_APP_API_ROUTE}/files/`;

    const handleDeleteClick = (type, photo) => {
        setPhotoToDelete({ type, photo });
        setConfirmOpen(true);
    };

    const handleConfirmDelete = () => {
        if (photoToDelete) {
            onDeleteClick(photoToDelete.type, photoToDelete.photo);
        }
        handleCloseConfirm();
    };

    const handleCloseConfirm = () => {
        setConfirmOpen(false);
        setPhotoToDelete(null);
    };

    return (
        <Box sx={{ my: 2, flex: 1, display: 'flex', flexDirection: 'column' }}>
            <Box elevation={0} sx={{ p: 2, flex: 1, display: 'flex', flexDirection: 'column', }}>

                <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                    {(!Array.isArray(currentPhotos) || currentPhotos.length === 0) ? (
                        <Box sx={{
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            py: 6,
                            borderRadius: '8px'
                        }}>
                            <Box sx={{
                                width: 56,
                                height: 56,
                                borderRadius: '50%',
                                // backgroundColor: '#f5f5f5',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                mb: 2,
                                fontSize: '24px'
                            }}>
                                {activeTab === "food" ? "🍽️" : "✨"}
                            </Box>
                            <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                                No {photoLabel} photos added yet
                            </Typography>
                            <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
                                Add {photoLabel} photos to showcase your {activeTab === "food" ? 'dishes' : 'restaurant environment'} on the restaurant page.
                            </Typography>
                            {/* <CustomButton
                                onClick={() => onAddClick(currentType)}
                                startIcon={<AddIcon />}
                                height="40px"
                                width="160px"
                            >
                                Add Photos
                            </CustomButton> */}
                        </Box>
                    ) : (
                        <Grid container spacing={1}>
                            {currentPhotos.map((photo, index) => (
                                <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                                    <Box sx={{
                                        position: 'relative',
                                        height: "200px",
                                        borderRadius: 3,
                                        overflow: 'hidden',
                                        border: '1px solid #eee',
                                        cursor: 'pointer',
                                        transition: '0.3s',
                                        '&:hover': {
                                            transform: 'scale(1.03)',
                                        },
                                        '&:hover .delete-btn': { opacity: 1 },
                                        '&:hover .overlay': { opacity: 1 }
                                    }}>
                                        <Box
                                            component="img"
                                            src={`${imageBaseUrl}${photo}`}
                                            alt={`Res ${photoLabel}`}
                                            sx={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'cover'
                                            }}
                                        />
                                        <Box className="overlay" sx={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            width: '100%',
                                            height: '100%',
                                            backgroundColor: 'rgba(0,0,0,0.2)',
                                            opacity: 0,
                                            transition: 'opacity 0.2s'
                                        }} />
                                        <IconButton
                                            className="delete-btn"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleDeleteClick(currentType, photo);
                                            }}
                                            sx={{
                                                position: 'absolute',
                                                top: 8,
                                                right: 8,
                                                backgroundColor: '#ef4444',
                                                color: '#fff',
                                                padding: '4px',
                                                opacity: 0,
                                                transition: 'opacity 0.2s',
                                                '&:hover': { backgroundColor: '#dc2626' }
                                            }}
                                        >
                                            <DeleteIcon sx={{ fontSize: 16 }} />
                                        </IconButton>
                                    </Box>
                                </Grid>
                            ))}
                        </Grid>
                    )}
                </Box>
            </Box>

            <ConfirmationDialog
                open={confirmOpen}
                handleClose={handleCloseConfirm}
                handleConfirm={handleConfirmDelete}
                btnText="Delete"
                infoText={`Are you sure you want to delete this ${activeTab} photo?`}
                action="Delete Photo"
            />
        </Box>
    );
};

export default RestaurantPhotos;
